module.exports = __webpack_public_path__ + "img/der_02_dex.3c31c78a.png";